import NotificationsRightPanel from './NotificationsRightPanel.jsx'

export default NotificationsRightPanel
